import { useState } from 'react';
import { useSelector } from 'react-redux';
import PersonIcon from '@mui/icons-material/Person';
import { Box } from '@mui/material';

import { SwitchRegisterHistory } from './registerHistory';
import { useSwitchDetail } from './hook';
import { SwitchAccountInfo } from './accountInfo';
import { SwitchDetailGeneralInfo } from './generalInfo';
import { SwitchHistorical } from '../historical';

import { LayoutModule } from '../../../../layout/modules';
import { RootState } from '../../../../../redux/store';
import {
    isOnlyViewProfile,
    isSupervisor,
} from '../../../../../shared/types/profiles';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { SWITCH_EDIT, SWITCH } from '../../../../../routes/paths';
import { FunctionarySwitchDetail } from './functionaryInfo';

export const SwitchDetail = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [showHistorical, setShowHistorical] = useState(false);
    const { switchDetail, functionarySwitchDetail, loading, switchHistorical } =
        useSwitchDetail(showHistorical);

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    const additionalButtons =
        !isSupervisor(type) && !isOnlyViewProfile(type) ? (
            <ActionButtonGroup
                id={switchDetail?.id || ''}
                buttonCreate={{
                    show: false,
                }}
                buttonSearch={{
                    show: true,
                    route: SWITCH,
                }}
                buttonUpdate={{
                    show: !isOnlyViewProfile(type),
                    route: SWITCH_EDIT,
                }}
                buttonView={{
                    show: false,
                }}
                buttonLog={{
                    show: false,
                }}
                onHistoricalShow={toggleHistorical}
            />
        ) : undefined;

    return (
        <>
            <LayoutModule
                title="Detalle conmutador"
                titleChildren="Detalle cuenta"
                icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                additionalButtons={additionalButtons}
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <SwitchHistorical
                            historical={switchHistorical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}

                <SwitchAccountInfo
                    account={switchDetail?.account}
                    loading={loading}
                />
            </LayoutModule>
            <SwitchDetailGeneralInfo switchDetail={switchDetail} />
            <FunctionarySwitchDetail
                functionarySwitchDetail={functionarySwitchDetail}
            />
            <SwitchRegisterHistory switchDetail={switchDetail} />
        </>
    );
};
